import React from 'react';
import { Crown, Clock, Shield, Star, Zap, Heart } from 'lucide-react';

const WhyUsSection = () => {
  const reasons = [
    {
      icon: Crown,
      title: 'Unmatched Fleet',
      description: 'From Lamborghinis to Range Rovers, we offer the GTA\'s most exclusive collection.'
    },
    {
      icon: Clock,
      title: 'Flexible Rentals',
      description: 'Daily, weekly, or monthly. We work around your schedule, not the other way around.'
    },
    {
      icon: Shield,
      title: 'Fully Insured',
      description: 'Drive with confidence. Every vehicle comes with comprehensive coverage.'
    },
    {
      icon: Zap,
      title: 'Same-Day Pickup',
      description: 'Need a car today? We make it happen. Fast approval, faster keys in hand.'
    },
    {
      icon: Star,
      title: '5-Star Service',
      description: 'Our clients don\'t just rent cars—they come back. Every. Single. Time.'
    },
    {
      icon: Heart,
      title: 'Personal Touch',
      description: 'Not a corporation. We\'re car enthusiasts who treat every client like family.'
    }
  ];

  return (
    <section id="why-us" className="py-20 bg-black relative overflow-hidden">
      {/* Background accents */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-amber-500/30 to-transparent" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(212,160,23,0.03)_0%,transparent_70%)]" />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 animate-fadeInUp">
            Why
            <span className="text-gold-gradient"> Grand Line?</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto animate-fadeInUp animation-delay-100 leading-relaxed">
            We're not just renting cars—we're delivering experiences. 
            <span className="text-amber-400"> The GTA's premier luxury rental destination.</span>
          </p>
        </div>

        {/* Reasons Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="group relative p-6 rounded-2xl bg-gradient-to-b from-gray-900/50 to-black border border-gray-800/50 hover:border-amber-500/30 transition-all duration-500 animate-fadeInUp hover-lift"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {/* Icon */}
              <div className="w-12 h-12 bg-gradient-to-br from-amber-500/20 to-amber-600/5 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 group-hover:shadow-[0_0_20px_rgba(212,160,23,0.3)] transition-all duration-300">
                <reason.icon className="w-6 h-6 text-amber-400" />
              </div>
              
              {/* Content */}
              <h3 className="text-lg font-bold text-white mb-2 group-hover:text-amber-400 transition-colors">
                {reason.title}
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                {reason.description}
              </p>

              {/* Hover glow */}
              <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-amber-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-12 animate-fadeInUp animation-delay-700">
          <p className="text-gray-500 text-lg">
            Ready to experience the difference?
          </p>
          <button
            onClick={() => document.getElementById('inquiry')?.scrollIntoView({ behavior: 'smooth' })}
            className="mt-4 inline-flex items-center gap-2 text-amber-400 hover:text-amber-300 font-semibold transition-colors link-underline"
          >
            Get Your Dream Car Today
          </button>
        </div>
      </div>
    </section>
  );
};

export default WhyUsSection;
